import { Button } from "../../design_system/components/Button/Button.jsx";

const SelectAllButton = ({ allSelected, select_all_disabled, selectAllFilters }) => {
  return (
    <Button
      Size="Small"
      Type="Ghost"
      ShowLeadingIcon={true}
      LeadingIcon={allSelected ? "select-all" : "deselect-all"}
      LeadingIconProps={{ size: 24 }}
      disabled={select_all_disabled}
      onClick={() => selectAllFilters()}
    >
      {allSelected ? "Unselect All" : "Select All"}
    </Button>
  );
};

export default SelectAllButton;
